import { DocumentInverted, phxWebStyleTokens } from 'phx-core';

import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { IDpeNote } from '@lib/safety/events/events.interface';

@Component({
  selector: 'notes-popup',
  templateUrl: './notes-popup.component.html',
  styleUrls: ['./notes-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesPopupComponent implements OnInit {
  @Input() public notes: IDpeNote[] = [];
  @Input() public usePhxIcon: boolean = false;
  public phxWebStyleTokens = phxWebStyleTokens;
  public lastNote: IDpeNote;
  public multiNotesText: string;
  public readonly DocumentInverted: string = DocumentInverted;

  public get hasMultipleNotes(): boolean {
    return this.notes.length > 1;
  }

  public ngOnInit(): void {
    const notesLength: number = this.notes && this.notes.length;
    if (notesLength) {
      this.lastNote = this.notes[notesLength - 1];

      const notesPostFixText = notesLength > 2 ? 's' : '';
      // tslint:disable-next-line: max-line-length
      this.multiNotesText = this.hasMultipleNotes ? $localize`+${notesLength - 1} more note${notesPostFixText}` : '';
    }
  }
}
